export default "__VITE_ASSET__DPZrsNUr__"